export default "/images/a8f2dbacd25a5d9c94f92428242997ad.avif";